import React from 'react';
import Map from './components/Map';
import MapWrapper from './components/MapWrapper';
import MapItemRBB from './components/MapItemRBB';

const MapViewRBB = props => {
  const mapScale = props.mapScale || 1.0;
  const currentMap = props.map;
  const items = currentMap.items;

  const ref = props.mapRef;

  const childRefs = [...Array(Object.entries(items).length).keys()].map(e =>
    React.createRef()
  );

  const setRenderView = state =>
    childRefs.forEach(c => {
      c.current.setRenderView(state);
    });

  React.useImperativeHandle(ref, () => ({
    childFunction1() {
      setRenderView(true);
    }
  }));
  return (
    <MapWrapper>
      <Map data={currentMap} id={props.id}>
        {Object.keys(items).map((key, i) => {
          const item = items[key];
          return (
            <MapItemRBB
              initialPosition={item.data.defaultPosition}
              key={i}
              childRef={childRefs[i]}
              item={item}
              data={props.data}
              parentData={props.parentData}
              mapScale={mapScale}
              renderView={Boolean(props.renderView)}
              setValueInMap={props.setValueInMap}
            />
          );
        })}
      </Map>
    </MapWrapper>
  );
};
export default MapViewRBB;
